import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface AddressData {
    label?: string;
    recipientName?: string;
    phone?: string;
    fullAddress?: string;
    postalCode?: string | number;
}

interface AddressCardProps {
    address?: AddressData | null;
    onClick?: () => void;
    className?: string;
}

const AddressCard: React.FC<AddressCardProps> = ({
    address,
    onClick,
    className,
}) => {
    const isFilled = Boolean(
        address && (address.fullAddress || address.recipientName)
    );

    return (
        <button
            onClick={onClick}
            type='button'
            className={cn(
                'w-full rounded-[16px] p-3 shadowCard transition cursor-pointer flex items-center justify-between gap-3',
                className
            )}
        >
            <div className="flex flex-col gap-1.5 flex-1 min-w-0  items-start">
                <span className="uppercase body2 text-text-grey">
                    ALAMAT PENGIRIMAN
                </span>

                {isFilled ? (
                    <>
                        <h4 className="title3medium text-black truncate">
                            {address?.label ? `${address.label} - ` : ''}
                            {address?.recipientName}
                        </h4>
                        {address?.phone && (
                            <p className="body2 text-text-grey">
                                {address.phone}
                            </p>
                        )}
                        <p className="body2 text-text-grey line-clamp-2 text-start">
                            {address?.fullAddress}
                        </p>
                        {address?.postalCode && (
                            <p className="body2 text-text-grey">
                                {address.postalCode}
                            </p>
                        )}
                    </>
                ) : (
                    <>
                        <h4 className="title3medium">
                            Tambah Alamat Pengiriman
                        </h4>
                        <p className="body2 text-text-grey">
                            Masukkan alamat tujuan pengiriman pesanan anda.
                        </p>
                    </>
                )}
            </div>

            <ChevronRight className="w-5 h-5 text-black shrink-0" />
        </button>
    );
};

export default AddressCard;